import { cache } from "lib/apolloClient";
import {
  getEntireUnitFlowFeedQuery,
  getUnitFlowFeedQuery,
  getUnitResourcesFeedQuery,
  getLearningCourseFlowResourceQuery,
} from "./Query";
import { unitFlowFragmentWithoutDepth } from "./Fragments";

// TODO: unused, remove later
export const getUnitFlowFeedQueryFromCache = variables => {
  return cache.readQuery({
    query: getUnitFlowFeedQuery,
    variables,
  });
};

export const getUnitFlowItemFromCache = ({ id, variables }) => {
  let fragmentData = {};
  try {
    fragmentData = cache.readFragment({
      id: `LearningCourseFlow:${id}`,
      fragment: unitFlowFragmentWithoutDepth.unitFlowWithChildren,
      fragmentName: "unitFlowWithChildrenItem",
      variables,
    });
  } catch (e) {
    return {};
  }
  return fragmentData;
};

export const writeUnitFlowItemInCache = ({ id, variables, data }) => {
  cache.writeFragment({
    id: `LearningCourseFlow:${id}`,
    fragment: unitFlowFragmentWithoutDepth.unitFlowWithChildren,
    fragmentName: "unitFlowWithChildrenItem",
    variables,
    data,
  });
};

export const getEntireUnitFlowFeedQueryFromCache = variables => {
  return cache.readQuery({
    query: getEntireUnitFlowFeedQuery,
    variables,
  });
};

export const getUnitResourcesFeedQueryFromCache = variables => {
  return cache.readQuery({
    query: getUnitResourcesFeedQuery,
    variables,
  });
};

export const getLearningCourseFlowResourceFromCache = ({ id }) => {
  return cache.readQuery({
    query: getLearningCourseFlowResourceQuery,
    variables: { id },
  });
};
